export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ProtocolloAnteprima.vue?vue&type=template&id=2b14ab86&"


//////////////////
// WEBPACK FOOTER
// ./modules/Home/views/src/components/ProtocolloAnteprima.vue?vue&type=template&id=2b14ab86&
// module id = 881
// module chunks = 0